import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@mui/material';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../../i18n/constants/keys';
import { Button } from '../../../../../../../ui';
import { EyeIcons } from '../../../../../../../icons/icons';

interface HeaderCardProps {
  onPreviewClick: () => void;
  onImportClick: () => void;
  isImported: boolean;
}

export const HeaderCard: React.FC<HeaderCardProps> = ({
  onPreviewClick,
  onImportClick,
  isImported,
}) => {
  const { t } = useTranslation(NS.adminPages);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        p: 2,
        boxShadow: (theme) => theme.shadows[1],
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1.5,
          alignItems: { sm: 'center' },
          justifyContent: { sm: 'space-between' },
        }}
      >
        <Box>
          <Typography variant='subtitle2' sx={{ fontWeight: 800, color: 'text.primary' }}>
            {t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.details.roleDetails)}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
          <Button
            onClick={onPreviewClick}
            variant='secondary'
            label={t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.details.publicFacingPreview)}
            sx={{ width: { xs: '100%', sm: 'auto' }, fontWeight: 600 }}
            icon={<EyeIcons size={20} />}
            hasIcon
          />
          <Button
            onClick={onImportClick}
            variant={isImported ? 'secondary' : 'primary'}
            label={
              isImported
                ? t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.details.undoImports)
                : t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.details.importFromJD)
            }
            sx={{ width: { xs: '100%', sm: 'auto' }, fontWeight: 600 }}
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default HeaderCard;
